import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { PoAutoPageRoutingModule } from './po-auto-routing.module';

import { PoAutoPage } from './po-auto.page';
import { IonicSelectableModule } from 'ionic-selectable';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    PoAutoPageRoutingModule,
    IonicSelectableModule
  ],
  declarations: [PoAutoPage]
})
export class PoAutoPageModule {}
